
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 19 19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.472 2.666c.246 0 .445.2.445.445v11.3c0 .23-.175.422-.403.443l-.18.017a19.79 19.79 0 00-7.568 2.283l-.653.352c-.02.01-.04.016-.06.023-.014.005-.025.011-.038.015a.433.433 0 01-.224 0c-.013-.004-.025-.01-.037-.015-.021-.007-.042-.013-.062-.023l-.653-.352a19.78 19.78 0 00-7.567-2.283l-.18-.017a.444.444 0 01-.403-.442V3.11c0-.245.199-.445.444-.445 2.89 0 5.745.76 8.253 2.195l.317.181.317-.18a16.636 16.636 0 018.252-2.196zm-.444.896c-2.583.073-5.121.785-7.366 2.07l-.315.18V16.37a20.673 20.673 0 017.68-2.362zm-16.25 0v10.446a20.675 20.675 0 017.68 2.362V5.812l-.313-.18a15.75 15.75 0 00-7.367-2.07zm1.013 8.247c.134-.015 3.312-.328 5.743 1.293l-.493.74c-2.16-1.44-5.128-1.153-5.158-1.15zm8.48 1.293c2.431-1.62 5.61-1.308 5.744-1.293l-.093.883c-.03-.003-2.998-.29-5.158 1.15zM2.78 9.606c.132-.017 3.295-.407 5.755 1.241l-.495.74c-2.177-1.46-5.116-1.104-5.146-1.1zm8.49 1.241c2.46-1.648 5.623-1.258 5.756-1.241l-.115.881c-.03-.004-2.969-.36-5.146 1.099zm-8.465-3.55c.138-.01 3.4-.229 5.731 1.343l-.497.737C5.965 7.979 2.901 8.18 2.87 8.183zM11.27 8.64C13.6 7.069 16.862 7.286 17 7.296l-.065.887c-.03-.003-3.096-.204-5.17 1.194zm1.307-2.949c1.874-.862 4.331-.636 4.434-.626l-.085.885c-.023-.003-2.325-.212-3.977.549zm-9.783-.626c.103-.01 2.561-.236 4.434.626l-.371.807c-1.653-.76-3.954-.55-3.977-.548z"}})])
          )
        }
      }
    